<template>
    <v-layout row wrap class="contact-us-block">
        <v-flex
            xs12
            mb-2
            v-for="myAccountContact in contactUsConstants.menu"
            v-if="isSpeakerView ? myAccountContact.showForExternalSpeaker : myAccountContact.showForMember"
            :key="myAccountContact.key">
            <v-flex class="contact-us cursor">{{ myAccountContact.title }}</v-flex>
            <v-flex class="description" v-if="myAccountContact.description">{{ myAccountContact.description }}</v-flex>
            <v-flex class="url" v-if="myAccountContact.urlTitle">
                <a
                    :href="`mailto:${myAccountContact.url}`"
                    target="_top"
                    slot="header"
                    class="contact-us url"
                    :data-qe-id="'contact_'+myAccountContact.key"
        >{{myAccountContact.urlTitle}}</a>
            </v-flex>
        </v-flex>
        <v-flex class="phone-details">
            <v-flex xs12 class="contact-us cursor">{{ contactUsConstants.MEMBER_SERVICES_NUMBER }}</v-flex>
        </v-flex>        
    </v-layout>
</template>

<script>
import { contactUsConstants } from "./myaccount.constants.js";
import { mapGetters } from "vuex";
import { storeGetters } from "../../store/storeGetters.constant";

export default {
    name: "ContactUs",
    data: () => ({
        contactUsConstants,
    }),
    computed: {
        ...mapGetters({
            isSpeakerView: `auth/${storeGetters.isSpeakerView}`,
        }),
    },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.contact-us-block {
    background: $ypo-extra-light-gray;
    padding: 10px 0px;
}

.contact-us {
    color: $ypo_blue;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 5px 25px;
}

.url {
    text-transform: initial;
    text-decoration: none;
    color: $ypo-cta;
    font-size: 12px;
    line-height: 24px;
    margin-top: -5px;
    letter-spacing: 0.29px;
    font-weight: 400;
}

.description {
    color: rgba($black, 0.9);
    font-size: 12px;
    line-height: 24px;
    margin-top: -5px;
    letter-spacing: 0.29px;
    font-weight: 400;
    padding: 0px 25px;
}

.cursor {
    cursor: default;
}

.phone-details {
    border-top: 1px solid $ypo-medium-gray;
    border-bottom: 1px solid $ypo-medium-gray;
    padding: 5px 0px;
    margin: 10px 0;
}
</style>
